import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgTrendingIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M6.051 10.908C1.441 16.298 5.67 20.562 8.343 22c-2.494-3.944 1.039-9.038 3.117-11.092-.191.616-.458 2.465 0 4.93.458 2.464 3.246 1.848 4.583 1.232.459 1.479-.19 3.903-.573 4.93 2.75-1.972 4.034-5.34 4.332-6.779C21.177 9.798 15.066 4.465 12.01 2c-2.4 4.762-1.6 3.81-5.96 8.908Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgTrendingIcon);
const Memo = memo(ForwardRef);
export default Memo;
